module.exports = __webpack_public_path__ + "static/img/cm.a0e1bf1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/staff/cm.jpg
// module id = 205
// module chunks = 1